import { createSlice } from "@reduxjs/toolkit";
import { PlansType } from "../../../types/plansType";
import { call, put } from "redux-saga/effects";
import { ShowAlert } from "../alertWindowSlice";
import { getPlansListReq } from "../../../api/activation/plansReq";
import { ApiResType } from "../../../types/apiTypes";

type payloadType = {
  data: PlansType[];
};

export interface PlansSlicetypes {
  error: boolean;
  message: string;
  data: PlansType[];
  loading: boolean;
}

const initialState: PlansSlicetypes = {
  error: false,
  message: "",
  data: [],
  loading: false,
};

const PlansSlice = createSlice({
  name: "Plans",
  initialState: initialState,
  reducers: {
    GetPlans: (
      state: PlansSlicetypes,
      { payload }: { payload: payloadType }
    ) => {
      state.error = false;
      state.data = payload ? [...payload.data] : [];
      state.loading = false;
      return state;
    },
    StartLoading: (state: PlansSlicetypes) => {
      state.loading = true;
      return state;
    },
    StopLoading: (state: PlansSlicetypes) => {
      state.loading = false;
      return state;
    },
    ClearData: (state: PlansSlicetypes) => {
      state = initialState;
      return state;
    },
  },
});

export const { GetPlans, StartLoading, StopLoading, ClearData } =
  PlansSlice.actions;

export default PlansSlice.reducer;

export function* getPlansList({ payload }: any) {
  interface ApiResType2 extends ApiResType {
    recent: any;
  }
  try {
    yield put(StartLoading());
    const res: ApiResType2 = yield call(getPlansListReq);
    yield put(GetPlans({ data: res?.data }));
  } catch (error: any) {
    yield put(GetPlans({ data: [] }));
    yield put(StopLoading());
    yield put(ShowAlert({ typeIs: "failure", alertMsg: error?.errorMsg }));
    console.log(error, "error from redux-saga");
  }
}
